export var ServiceOverviewGroupByUnit;
(function (ServiceOverviewGroupByUnit) {
    ServiceOverviewGroupByUnit["pods"] = "";
    ServiceOverviewGroupByUnit["nodes"] = "%";
    ServiceOverviewGroupByUnit["environments"] = "";
})(ServiceOverviewGroupByUnit || (ServiceOverviewGroupByUnit = {}));
//# sourceMappingURL=service-overview-groupby-unit.enum.js.map